//DropdownMenu.js
import { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { AuthContext } from "../../providers/AuthProvider";
import DropdownItem from "./DropdownItem";

// icons
import { test } from "../icons/test";
import { Icon } from "../../components/icons/Icon";
import { chevronRight, chevronLeft, cog, info, blank } from "../icons/appIcons";
import { logout, user } from "../icons/authIcons";

const DropdownMenu = (props) => {
  const [activeMenu, setActiveMenu] = useState("main");
  const [menuHeight, setMenuHeight] = useState(null);
  const navigate = useNavigate();
  const { isLoggedIn } = useContext(AuthContext);
  // const [isOpen, setIsOpen] = useState(false);

  const location = useLocation();
  const prevKeyRef = useRef(location.key); // capture key on mount

  useEffect(() => {
    if (location.key !== prevKeyRef.current) {
      prevKeyRef.current = location.key; // update for next time
      if (props.open) props.setOpen(false);
    }
  }, [location.key, props.open, props.setOpen]);

  const toggleDropdown = (e) => {
    // e.preventDefault();
    props.setOpen(!props.open);
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    toggleDropdown();

    if (isLoggedIn) navigate("/logout", { replace: true });
  };

  // const dropdownRef = useRef(null);
  // const nodeRef = useRef(null);
  const primaryRef = useRef(null);
  const secondaryRef = useRef(null);

  // useEffect(() => {
  //   setMenuHeight(dropdownRef.current?.firstChild.offsetHeight);
  // }, []);

  function calcElementHeight(node) {
    const height = node.offsetHeight;
    setMenuHeight(height);
  }

  // function DropdownItem(props) {
  // return (
  //   <a href="#" className="menu-item" onClick={() => props.goToMenu && setActiveMenu(props.goToMenu)}>
  //     <span className="icon-button">{props.leftIcon}</span>
  //     {props.children}
  //     <span className="icon-right">{props.rightIcon}</span>
  //   </a>
  // );
  // }

  return (
    <div
      id="app_dd_menu"
      className="right-dropdown"
      role="menu"
      style={{ height: menuHeight }}
      // ref={dropdownRef}
    >
      <CSSTransition
        nodeRef={primaryRef}
        in={activeMenu === "main"} //this cannot be array, breaks submenu navigation
        timeout={500}
        classNames="dd-menu-primary"
        unmountOnExit
        onEnter={calcElementHeight}
      >
        <div className="dd-menu" ref={primaryRef}>
          <DropdownItem
            as="link"
            to="/profile"
            onSelect={toggleDropdown} // close menu after click
            leftIcon={
              <Icon
                icon={user}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-left"
              />
            }
            className="dd-item"
          >
            My Profile
          </DropdownItem>
          {/* <DropdownItem
            leftIcon={
              <Icon
                icon={user}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-left"
              />
            }
            className="dd-item"
          >
            My Profile
          </DropdownItem> */}

          <DropdownItem
            as="link"
            to="/settings"
            onSelect={toggleDropdown} // close menu after click
            leftIcon={
              <Icon
                icon={cog}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-left"
              />
            }
            className="dd-item"
          >
            Settings
          </DropdownItem>
          {/* <DropdownItem
            to="/settings"
            onClick={toggleDropdown}
            leftIcon={
              <Icon
                icon={cog}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-left"
              />
            }
            className="dd-item"
          >
            Settings
          </DropdownItem> */}

          {/* <Link to="/settings" onClick={toggleDropdown}>
            <DropdownItem
              leftIcon={
                <Icon
                  icon={cog}
                  size={24}
                  width={24}
                  height={24}
                  strokeWidth={1}
                  className="pointer-events-none icon-left"
                />
              }
              className="dd-item"
            >
              Settings
            </DropdownItem>
          </Link> */}
          {/* <Link to="/logout" onClick={handleLogout}>
            <DropdownItem
              leftIcon={
                <Icon
                  icon={logout}
                  size={24}
                  width={24}
                  height={24}
                  strokeWidth={1}
                  className="pointer-events-none icon-left"
                />
              }
              className="dd-item"
            >
              Logout
            </DropdownItem>
          </Link> */}
          <DropdownItem
            as="link"
            to="/logout"
            onSelect={handleLogout} // close menu after click
            leftIcon={
              <Icon
                icon={logout}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-left"
              />
            }
            className="dd-item"
          >
            Logout
          </DropdownItem>
          {/* <DropdownItem
            to="/logout"
            onClick={handleLogout}
            leftIcon={
              <Icon
                icon={logout}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-left"
              />
            }
            className="dd-item"
          >
            Logout
          </DropdownItem> */}
          <DropdownItem
            as="link"
            to="/toat"
            onSelect={toggleDropdown} // close menu after click
            leftIcon={
              <Icon
                icon={blank}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-left"
              />
            }
            className="dd-item"
          >
            TOAT
          </DropdownItem>
          <DropdownItem
            as="button"
            goToMenu="testmenu"
            setActiveMenu={setActiveMenu}
            className="dd-item"
            leftIcon={
              <Icon
                icon={test}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-left"
              />
            }
            rightIcon={
              <Icon
                icon={chevronRight}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-right"
              />
            }
          >
            Tests
          </DropdownItem>

          {/* <DropdownItem
            leftIcon={
              <Icon
                icon={test}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-left"
              />
            }
            rightIcon={
              <Icon
                icon={chevronRight}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-right"
              />
            }
            goToMenu="testmenu"
            className="dd-item"
            setActiveMenu={setActiveMenu}
          >
            Tests
          </DropdownItem> */}
        </div>
      </CSSTransition>

      <CSSTransition
        nodeRef={secondaryRef}
        in={activeMenu === "testmenu"}
        timeout={500}
        classNames="dd-menu-secondary"
        unmountOnExit
        onEnter={calcElementHeight}
      >
        <div className="dd-menu" ref={secondaryRef}>
          <DropdownItem
            as="button"
            goToMenu="main"
            setActiveMenu={setActiveMenu}
            className="dd-item"
            leftIcon={
              <Icon
                icon={chevronLeft}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-left"
              />
            }
          >
            Main
          </DropdownItem>

          {/* <DropdownItem
            goToMenu="main"
            setActiveMenu={setActiveMenu}
            leftIcon={
              <Icon
                icon={chevronLeft}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-left"
              />
            }
            className="dd-item return"
          >
            Main
          </DropdownItem> */}
          {/* <DropdownItem
            leftIcon={<BoltIcon className="icon-left" />}
            onClick={handleThemeToggle}
            className="dd-item"
          >
            Toggle Theme
          </DropdownItem> */}
          {/* <Link to="/test" onClick={toggleDropdown}>
            <DropdownItem
              leftIcon={
                <Icon
                  icon={test}
                  size={24}
                  width={24}
                  height={24}
                  strokeWidth={1}
                  className="pointer-events-none icon-left"
                />
              }
              className="dd-item"
            >
              HTTP Tests
            </DropdownItem>
          </Link> */}
          <DropdownItem
            as="link"
            key="/test"
            to="/test"
            onSelect={toggleDropdown} // close menu after click
            leftIcon={
              <Icon
                icon={test}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-left"
              />
            }
            className="dd-item"
          >
            HTTP Tests
          </DropdownItem>
          <DropdownItem
            as="link"
            to="/shrtr"
            onSelect={toggleDropdown} // close menu after click
            leftIcon={
              <Icon
                icon={test}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-left"
              />
            }
            className="dd-item"
          >
            Shrtr
          </DropdownItem>
          {/* <DropdownItem
            to="/test"
            onClick={toggleDropdown}
            leftIcon={
              <Icon
                icon={test}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-left"
              />
            }
            className="dd-item"
          >
            HTTP Tests
          </DropdownItem> */}

          <DropdownItem
            as="a"
            href="https://developer.mozilla.org/en-US/docs/Web/CSS"
            target="_blank"
            rel="noopener noreferrer"
            onSelect={toggleDropdown}
            leftIcon={
              <Icon
                icon={info}
                size={24}
                width={24}
                height={24}
                strokeWidth={1}
                className="pointer-events-none icon-left"
              />
            }
            className="dd-item"
          >
            External CSS Info
          </DropdownItem>
        </div>
      </CSSTransition>
    </div>
  );
};

export default DropdownMenu;
